import { gsap } from 'gsap';

export function initializeForminatorSuccess() {
  if (!window.jQuery) {
    return;
  }

  window.jQuery(document).on('forminator:form:submit:success', (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('.forminator-custom-form')
    ) {
      return;
    }

    const response = form.querySelector(
      '.forminator-response-message.forminator-success',
    );

    if (!response?.hasChildNodes() || form.inert) {
      return;
    }

    const success = document.createElement('div');
    success.className = 'site-form-success';
    success.setAttribute('role', 'status');
    success.setAttribute('aria-live', 'polite');
    success.tabIndex = -1;
    success.append(...response.childNodes);

    form.before(success);
    form.inert = true;
    form.setAttribute('aria-hidden', 'true');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      form.style.display = 'none';
      success.focus({ preventScroll: true });
      return;
    }

    gsap.set(form, { height: form.offsetHeight, overflow: 'hidden' });
    gsap.set(success, { height: 0, opacity: 0, overflow: 'hidden' });

    gsap
      .timeline({
        onComplete: () => {
          gsap.set(success, { clearProps: 'height,opacity,overflow' });
          success.focus({ preventScroll: true });
        },
      })
      .to(form, {
        height: 0,
        opacity: 0,
        duration: 0.45,
        ease: 'power2.inOut',
        onComplete: () => {
          form.style.display = 'none';
          gsap.set(form, { clearProps: 'height,opacity,overflow' });
        },
      })
      .to(success, {
        height: 'auto',
        opacity: 1,
        duration: 0.35,
        ease: 'power2.out',
      });
  });
}
